export function isValidID(ID){
  return ID
    && ID !== 'undefined'
    && ID !== null
    && ID !== 'N/A'
}
